// Autogenerated by Kyd Editor File->Generate Boilerplate
// You man customise this code if you wish, it will NOT be overwritten.

import kotlinx.browser.window
import uk.co.nickthecoder.glok.application.Application
import uk.co.nickthecoder.glok.application.launchInContainer
import uk.co.nickthecoder.glok.scene.Stage
import uk.co.nickthecoder.kyd.Launcher

class Main : Application() {
    override fun start(primaryStage: Stage) {
        var base = window.location.toString()
        if (base.endsWith("/index.html")) {
            base = base.substring(0, base.length - 11)
        } else if (base.endsWith("/")) {
            base = base.substring(0, base.length - 1)
        }
        val kydPath = "$base/cavernQuest2.kyd"
        println( "Kyd file '$kydPath'" )

        registerTypes()
        Launcher.play(primaryStage, kydPath)
    }
}

fun main() {
    window.onload = {
        launchInContainer(Main::class, "glokContainer")
    }
}
